import { Box } from '../../shared-components/Box';
import { Section } from '../brite-viewer-v2/Section';
import { useContent, Content } from '../brite-viewer-v2/ContentProvider';

const briteContentStyles = `
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    width: 100%;
    opacity: 100%;
    overflow: hidden;

    * {
      box-sizing: border-box;
    }

    [data-row-id] {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      page-break-before: auto !important;
      break-before: auto !important;
    }

    .row {
      z-index: 5;
      a {
        color: inherit;
        text-decoration: inherit;
      }
    }

    pre {
      white-space: pre-wrap;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }

  `;

export const PDFPageV2 = () => {
  const content = useContent();

  const displaySettings = Content.getResource(content, 'displaySettings');
  const viewContent = Content.getContent(content);
  const mediaType = Content.getViewMode(content);

  if (!viewContent || !displaySettings) {
    return null;
  }

  return (
    <div
      css={`
        position: sticky;
        top: 0;
        background-color: var(--background-color);
        box-sizing: border-box;
        width: 100%;
        overflow-x: hidden;
        ${mediaType !== 'pdf' ? 'padding-top: 4px;' : ''}
      `}
      style={viewContent?.root?.containerStyle || {}}
    >
      <Box className="_brite-content" css={briteContentStyles}>
        {viewContent?.sections?.map((section) => (
          <Section key={section.id} id={section.id} />
        ))}
      </Box>
      <div style={{ breakAfter: 'page' }} />
    </div>
  );
};
